export type StepUpErrorCode =
  // invalid_grant on the step-up grant — wrong code, or a subject_token issue the OAuth
  // contract intentionally doesn't distinguish from a wrong code (see client.ts).
  | 'invalid_code'
  // temporarily_unavailable on the step-up grant — terminal, no retry.
  | 'rate_limited'
  // 401 on /step-up/initiate — the accessToken passed in is invalid/expired.
  | 'invalid_access_token'
  // 403 on /step-up/initiate — the step-up grant isn't enabled for this OAuth client.
  | 'not_enabled'
  // fetch failed (no response reached the SDK) or an unexpected server response.
  | 'network_error'
  // the user dismissed the form before completing it.
  | 'cancelled'
  // a step-up modal was already open — an integration mistake, not something the user did.
  | 'already_open'

export class StepUpError extends Error {
  constructor(
    public readonly code: StepUpErrorCode,
    message: string,
  ) {
    super(message)
    this.name = 'StepUpError'
  }
}
